<div class="left-icons chat-input-actions">
  <!-- start a New Chat -->
  <button
    mat-icon-button
    type="button"
    (click)="onNewChatClick()"
    *ngIf="true"
    matTooltip="Clear chat"
    matTooltipPosition="below"
  >
    <mat-icon>clear_all</mat-icon>
  </button>

  <!-- File Upload -->
  <button
    mat-icon-button
    type="button"
    (click)="onUploadFileClick()"
    [disabled]="isUploadButtonDisabled"
    [ngClass]="{ uploaded: uploadedFile }"
    [matTooltip]="fileTooltip"
    matTooltipPosition="below"
  >
    <mat-icon>attach_file</mat-icon>
  </button>
  <input
    type="file"
    #fileInput
    (change)="onFileSelected($event)"
    [accept]="acceptFileTypes"
    [attr.capture]="isMobile ? 'environment' : null"
    hidden
  />

  <!-- Image Upload -->
  <button
    mat-icon-button
    type="button"
    (click)="onCaptureImageClick()"
    matTooltip="Capture image"
    matTooltipPosition="below"
  >
    <mat-icon>photo_camera</mat-icon>
  </button>
  <input
    type="file"
    #imageInput
    (change)="onFileSelected($event)"
    [accept]="acceptImageTypes"
    [attr.capture]="isMobile ? 'environment' : null"
    hidden
  />

  <!-- Prompts library -->
  <button
    mat-icon-button
    type="button"
    (click)="onShowComingSoon()"
    *ngIf="false"
    matTooltip="Instruction library"
    matTooltipPosition="below"
  >
    <mat-icon>toc</mat-icon>
  </button>

  <button
    mat-icon-button
    type="button"
    (click)="onScrollToBottom()"
    *ngIf="false"
    matTooltip="Scroll to bottom"
    matTooltipPosition="below"
  >
    <mat-icon>keyboard_double_arrow_down</mat-icon>
  </button>
  
  <button
    mat-icon-button
    type="button"
    (click)="onTestFunction()"
    *ngIf="false"
    matTooltip="Test"
    matTooltipPosition="below"
  >
    <mat-icon>bug_report</mat-icon>
  </button>
</div>